import * as React from 'react'

import { Box, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { UserSelect } from 'modules/automations/components/blocks/UserSelect'
import type { Action } from 'modules/automations/store/models/Action'

import { AutomationStep } from '../Step'
import { automationSteps } from '../Step/constants'
import { getActionName } from '../actionUtils'

interface Props {
  action: Action
  form: Form | undefined
  onClick: (event: React.SyntheticEvent) => void
  withLastSpacer: boolean
}

export const RequestReviewAction = observer(({ action, onClick, form, withLastSpacer }: Props) => {
  const [tooltipOpen, toggleTooltip] = useToggle()

  const isDefault = () => {
    const automation = action.automation

    if (!automation) return true

    return automation.isDefault
  }

  const { access_id } = form?.data() as unknown as { access_id: string }
  const validRecipient = !!access_id

  return (
    <AutomationStep
      action={action}
      disabled={isDefault()}
      onClick={onClick}
      stepType={automationSteps.action}
      title={getActionName(action)}
      withLastSpacer={withLastSpacer}
      conflict={!validRecipient}
    >
      <Tooltip.Dialog
        open={tooltipOpen}
        toggle={toggleTooltip}
        attachment="bottom center"
        label={i18n.t('automations.add_block.action_types.deprecated_request_review_message')}
      >
        <Box paddingX="s16" paddingBottom="s16">
          <FormComponent>
            {/* DO NOT REMOVE THE DISABLED PROP */}
            {/* We are deprecating this Request Review, we don't want users to be able to edit existing ones */}
            <UserSelect users={users.models} disabled field={form?.get('access_id')} />
          </FormComponent>
        </Box>
      </Tooltip.Dialog>
    </AutomationStep>
  )
})
